module.exports = __webpack_public_path__ + "static/drop.14376882.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/drop.png
// module id = 540
// module chunks = 1